import {lazyComponent} from 'coreUtils/adapters/lazy';

const NotifyMePopup = lazyComponent(() => import('./NotifyMePopup'));

export {NotifyMePopup as default};
